<template>
  <div>
    <!--<CPortada :pseccion="pseccion"></CPortada>-->

    <Cbarra>
        <template slot="slotTitle">Directorio</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="#">Nosotros</a> / <router-link :to="{name:'directorio'}">Directorio</router-link>
        </template>
    </Cbarra>

    <div class="container">
        <div class="bg-principal-02">
            <div class="row" v-for="(detalle,key5) in ListaDirectores" :key="key5">
                <div v-if="key5 > 0" class="col-12">
                    <hr class="divider-01">
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="row directorio-01 mti-3">
                        <div class="col-12">
                            <div class="tm-portfolio-item-03 tm-pase-item">
                                <div class="tm-portfolio-name-03 tm-pase-name">
                                    <img :src="RutaFileD+detalle.IdDirecorio.Imagen" class="img-fluid" alt="ENES">
                                </div>
                                <div class="tm-portfolio-description-03 tm-pase-description">
                                    <h4>{{detalle.IdDirecorio.Nombre +' '+detalle.IdDirecorio.Apellidos}}</h4>
                                    <div v-for="(puestodirect,key2puestod) in detalle.IdDirecorio.Puestos" :key="key2puestod">
                                            <h5>{{puestodirect.Nombre}}</h5>
                                               
                                    </div>
                                    
                                    <p>
                                        <i class="far fa-envelope mr-2"></i>
                                        <a :href="'mailto:'+detalle.IdDirecorio.Correo">{{detalle.IdDirecorio.Correo}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" >
                    <div class="row directorio-01">

                        <div class="col-12" v-for="(secres,key2) in detalle.Secretario" :key="key2">
                            
                            <div class="tm-portfolio-item tm-pase-item" v-for="(secres2,key4) in secres.Secretario" :key="key4">
                                <div class="tm-portfolio-name tm-pase-name">
                                    <img :src="RutaFileD+secres2.Imagen" class="img-fluid" alt="ENES">
                                </div>
                                <div class="tm-portfolio-description tm-pase-description">
                                    <h6>{{secres2.Nombre + secres2.Apellidos}}</h6>
                                    <div v-for="(puestosecre,key2puesto) in secres2.Puestos" :key="key2puesto">
                                            <p  class="color8" >
                                                <b>{{puestosecre.Nombre}}</b>
                                            </p>
                                    </div>
                                    <p>
                                        <i class="far fa-phone-alt mr-2"></i> <a :href="'tel:+'+secres2.Telefono">{{secres2.Telefono}}</a>
                                    </p>
                                    <p>
                                        <i class="far fa-envelope mr-2"></i>
                                        <a :href="'mailto:'+secres2.Correo"
                                            class="small">{{secres2.Correo}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                 </div>
            </div>


            <div class="col-12">
                <hr class="divider-01">
            </div>

            <div class="row" v-for="(detallek,keysecre1) in ListaSecretarios" :key="keysecre1">
                <div v-if="keysecre1 > 0" class="col-12">
                    <hr class="divider-01">
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="row directorio-01 mti-3">
                        <div class="col-12">
                            <div class="tm-portfolio-item-03 tm-pase-item">
                                <div class="tm-portfolio-name-03 tm-pase-name">
                                    <img :src="RutaFileD+detallek.Secretario.Imagen" class="img-fluid" alt="ENES">
                                </div>
                                <div class="tm-portfolio-description-03 tm-pase-description">
                                    <h4>{{detallek.Secretario.Nombre +' '+detallek.Secretario.Apellidos}}</h4>
                                    <div v-for="(puestosecretario2,key2puestosec2) in detallek.Secretario.Puestos" :key="key2puestosec2">
                                            <h5>{{puestosecretario2.Nombre}}</h5>   
                                    </div>
                                    <p>
                                        <i class="far fa-envelope mr-2"></i>
                                        <a :href="'mailto:'+detallek.Secretario.Correo">{{detallek.Secretario.Correo}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-for="(detallek2,keysecre2) in detallek.Asistente" :key="keysecre2">
                    {{detallek2.Nombre}}
                </div> -->
                
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" >
                    <div class="row directorio-01">

                        <div class="col-12" v-for="(detallek2,keysecre2) in detallek.Asistente" :key="keysecre2">
                            
                            <div class="tm-portfolio-item tm-pase-item" >
                                <div class="tm-portfolio-name tm-pase-name">
                                    <img :src="RutaFileD+detallek2.Imagen" class="img-fluid" alt="ENES">
                                </div>
                                <div class="tm-portfolio-description tm-pase-description">
                                    <h6>{{detallek2.Nombre + detallek2.Apellidos}}</h6>
                                   
                                    <div v-for="(puestoasistente2,key3aa) in detallek2.Puestos" :key="key3aa">
                                            <p  class="color8" >
                                                <b>{{puestoasistente2.Nombre}}</b>
                                            </p>
                                    </div>
                                    <p>
                                        <i class="far fa-phone-alt mr-2"></i> <a :href="'tel:+'+detallek2.Telefono">{{detallek2.Telefono}}</a>
                                    </p>
                                    <p>
                                        <i class="far fa-envelope mr-2"></i>
                                        <a :href="'mailto:'+detallek2.Correo"
                                            class="small">{{detallek2.Correo}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                    
            </div>


            

            
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'',
    data() {
        return {
            urlApi:'inicio/directorio',
            pseccion:'Directorio',
            ListaDirectores:[],
            ListaSecretarios:[],
            RutaFileD:''
        }
    },methods: {
         async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{}
                }
            ).then((res) => {
                console.log(res);
                this.ListaDirectores = res.data.Directores;
                this.ListaSecretarios = res.data.Secretario;
                this.RutaFileD = res.data.RutaFileD;
                
            });
        },
    },mounted() {
        this.Lista();
    },
}
</script>

<style>

</style>